import api from "~services/axios";

export default {
  // 医生客户列表
  queryMedicalList: params =>
    api.post("/api/crmMedicalCustomer/queryMedicalList", params, {
      timeout: 30000,
    }),

  // 团队字典配置
  apiQueryTeam: params => api.get("/api/crmcustomer/queryteam", params),
  // 新增客户
  apiAddCustom: params => api.post("/api/crmcustomer/add", params),

  // 客户列表
  apiGetCustomList: params =>
    api.post("/api/crmcustomer/query", params, { timeout: 30000 }),

  // 客户详情
  apiMedicalGetCustomDetail: params =>
    api.get("/api/crmMedicalCustomer/detail", { params }),
  // 客户详情-项目列表
  apiGetMedicalProjectDetail: params =>
    api.get("/api/crmMedicalCustomer/queryCustomerProject", { params }),

  // 删除客户
  apiMedicalDeleteCustom: params =>
    api.post("/api/crmMedicalCustomer/delete", params),

  // 修改客户信息，审核已通过的客户使用
  apiUpdateCustom: params => api.post("/api/crmcustomer/update", params),

  // 修正客户信息，审核未通过的客户使用
  apiCorrectionCustom: params =>
    api.post("/api/crmcustomer/updateApply", params),

  // 修改医生信息
  apiUpdateDoctor: params => api.post("/api/crmcustomer/update/doctor", params),

  // 获取客户详情内部项目列表
  apiGetProjectList: params =>
    api.get("/api/crmcustomer/queryCustomerProject", { params }),

  // 获取自己的客户申请列表
  // 未审核、审核通过、审核不通过所有状态的申请单就会被查询出来
  apiGetCustomerApplyList: params =>
    api.get("/api/crmcustomer/queryApply", { params }),

  // 普通销售修改自己提交的审核不通过的客户申请单（普通客户类型）
  apiUpdateCrmCustomer: params => api.post("/api/crmcustomer/add", params),

  // 普通销售修改自己提交的审核不通过的客户申请单（医生客户类型）
  apiUpdateDoctorCustomer: params =>
    api.post("/api/crmcustomer/add/doctor", params),

  // 更新对接客户的业务员
  apiUpdateMedicalCustomSalesman: params =>
    api.post("/api/crmMedicalCustomer/updateSalesman", params),

  // 客户联系人
  apiGetMedicalCustomContacts: params =>
    api.get("/api/crmMedicalCustomer/query/customer/convert", { params }),

  // 客户业务员
  apiGetMedicalCustomSalesman: params =>
    api.get("/api/crmMedicalCustomer/salesmanQuery", { params }),
  apiAddCustomSalesman: params =>
    api.post("/api/crmcustomer/addSalesman", params),
  apiDeleteMedicalCustomSalesman: params =>
    api.post("/api/crmMedicalCustomer/deleteSalesman", params),
  apiAddMedicalCustomSalesman: params =>
    api.post("/api/crmMedicalCustomer/addSalesman", params),

  // 最终客户
  apiGetMedicalFinallyCustom: params =>
    api.get("/api/crmMedicalCustomer/queryTheFinalCustomer", { params }),
  apiAddMedicalFinallyCustom: params =>
    api.post("/api/crmMedicalCustomer/addTheFinalCustomer", params),
  apiEditMedicalFinallyCustom: params =>
    api.post("/api/crmMedicalCustomer/updateTheFinalCustomer", params),
  apiDeleteMedicalFinallyCustom: params =>
    api.post("/api/crmMedicalCustomer/delTheFinalCustomer", params),

  // 客户拜访记录
  apiGetMedicalCustomVisits: params =>
    api.get("/api/crmMedicalCustomer/query/customer/visit", { params }),

  // 导出客户列表
  apiExportCustom: (params, config) =>
    api.post("/api/crmcustomer/export", { params }, config),

  // 客户商机列表
  apiGetMedicalCustomBusi: params =>
    api.get("/api/crmMedicalCustomer/query/customer/business", { params }),

  // 客户合同列表
  apiGetMedicalCustomCompact: params =>
    api.get("/api/crmMedicalCustomer/query/customer/contract", { params }),

  // 医院等级
  apiGetHospitalLevel: params =>
    api.get("/api/common/query/category", { params }),

  // 添加联系人
  apiAddMedicalConvert: params =>
    api.post("/api/crmMedicalCustomer/addConvert", params),

  // 修改联系人
  apiMedicalUpdateConvert: params =>
    api.post("/api/crmMedicalCustomer/updateConvert", params),

  // 删除联系人
  apiMedicalDeleteConvert: params =>
    api.post("/api/crmMedicalCustomer/deleteConvert", params),

  // 分配客户-查看客户获取医生列表
  apiMedicalGetDoctorList: params =>
    api.get("/api/crmcustomer/allocation/query", { params, timeout: 30000 }),

  // 分配客户保存
  apiSaveDoctorDistribute: params =>
    api.post("/api/crmcustomer/allocation/save", params),

  // 获取运营人员
  apiGetOperatorList: params =>
    api.get("/api/crmcustomer/query/operationuser", { params }),

  // 保存运营人员修改
  apiSaveOperatorChange: params =>
    api.post("/api/crmcustomer/updateoperation", params),

  // 客户档案列表
  apiGetMedicalCustomArchiveList: params =>
    api.get("/api/crmMedicalCustomer/query/customer/file", { params }),
  apiUploadMedicalFile: (params, config) =>
    api.post("/api/crmMedicalCustomer/upload/file", params, config),
  apiDeleteMedicalFile: params =>
    api.post("/api/crmMedicalCustomer/deletefile", params),

  // 机构驳回客户列表
  apiGetRefusedCustomer: params =>
    api.get("/api/crmorganization/query", { params }),
  apiBindCode: params => api.post("/api/crmorganization/updateOrg", params),
  apiReplyAgain: params => api.post("/api/crmorganization/applyOrg", params),

  // 政府客户列表
  apiGetGovernmentData: params => api.get("/api/govInspect/query", { params }),
  apiDeleteGovernmentCus: params => api.post("/api/govInspect/delete", params),
  apiAddGovernmentCus: params => api.post("/api/govInspect/add", params),
  apiGetBusiLine: params => api.get("/api/govInspect/group", { params }),
  apiGetInvestigationPerson: params =>
    api.get("/api/govInspect/clues/query", { params }),
  apiGetGovernmentDetail: params =>
    api.get("/api/govInspect/detail", { params }),
  apiEditGovernmentCus: params => api.post("/api/govInspect/update", params),
  apiGetProjectData: params =>
    api.get("/api/govInspect/project/query", { params }),
  apiAddProject: params => api.post("/api/govInspect/project/add", params),
  apiDeleteProject: params =>
    api.post("/api/govInspect/project/delete", params),
  apiEditProject: params => api.post("/api/govInspect/project/update", params),
  apiDeleteProjectFollow: params =>
    api.post("/api/govInspect/project/record/delete", params),
  apiGetProFollowList: params =>
    api.get("/api/govInspect/project/record/query", { params }),
  apiAddProjectFollow: params =>
    api.post("/api/govInspect/project/record/add", params),
  apiEditProjectFollow: params =>
    api.post("/api/govInspect/project/record/update", params),

  // 全部医生列表
  apiGetDoctorData: params => api.get("/api/crmdoctor/query", { params }),
  // 客户新增判断客户保有量
  apiGetCustomerHold: params =>
    api.get("/api/crmcustomer/checkCustomerHolding", { params }),
  // 客户查重列表
  searchCustomerRepeat: params =>
    api.get("/api/crmcustomer/searchCustomerRepeat", { params }),
};
